import { hasItems } from "./tsUtils";

export function isChecked<K>(list: K[] | undefined, key: K) {
  return hasItems(list) && list.find((id) => id === key) !== undefined;
}
